import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../constants'
import { lightImpactVibrate } from '../../utils/appBridge'

type TextAndInfoPropTypes = {
  text: string
  onInfoClick: (e?: any) => void
  textClassName?: string
  /** When true, text is exposed as an h2 section heading (Details B31). */
  asHeading?: boolean
  headingLevel?: 2 | 3
}

export default function TextAndInfo({
  text,
  onInfoClick,
  textClassName,
  asHeading = true,
  headingLevel = 2
}: TextAndInfoPropTypes) {
  const HeadingTag = headingLevel === 3 ? 'h3' : 'h2'
  const textClasses = `text-[#232323] text-[14px] font-[700] m-0 ${textClassName ?? ''}`

  return (
    <div className='flex items-center gap-[7px]'>
      {asHeading ? (
        <HeadingTag className={textClasses}>{text}</HeadingTag>
      ) : (
        <div className={textClasses}>{text}</div>
      )}
      <button
        type='button'
        aria-label={`More information about ${text}`}
        onClick={(e) => {
          lightImpactVibrate()
          onInfoClick(e)
        }}
        className='inline-flex items-center justify-center min-w-[44px] min-h-[44px] -my-[10px] -mx-[16px] p-0 border-none bg-transparent cursor-pointer'
      >
        <img
          src={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/info-icon.svg`}
          alt=''
          aria-hidden='true'
          className='w-[12px] h-[12px]'
        />
      </button>
    </div>
  )
}
